import AdminLayout from "../../../components/admin/layout/AdminLayout";
import useAuthStore from "../../../store/authStore";
import ManagerSidebar from "../../../components/managerLiveDashboard/sidebar/ManagerSidebar";
import BidList from "../../../components/common/bid/BidList";

function BidListPage() {
  const { userType } = useAuthStore();

  return (
    <AdminLayout
      sidebarComponent={userType === 'admin' ? undefined : ManagerSidebar}
    >
      <BidList />
    </AdminLayout>
  );
}

export default BidListPage;
